import React, {Suspense} from 'react'
import SpinnerCustom from '@ui/spinner/SpinnerCustom'
import PageLayout from '@view/layout/pageLayout/PageLayout'
import {ReportTrackerOutagesLazy} from '@containers/reports/readyReports/reportTrackerOutages/ReportTrackerOutages.lazy'

const ReportTrackerOutagesPage = () => {
    return (
        <PageLayout>
            <Suspense
                fallback={<SpinnerCustom/>}
            >
                <ReportTrackerOutagesLazy/>
            </Suspense>
        </PageLayout>
    );
};

export default ReportTrackerOutagesPage;
